import { CommonModule } from '@angular/common';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { NgModule } from '@angular/core';
import { environment } from '../../../environments/environment';
import { InMemoryBackendMockService } from './services/in-memory-data.service';


@NgModule({
  imports: [CommonModule,
    ...(environment.production ? [] :  [HttpClientInMemoryWebApiModule.forRoot(
      InMemoryBackendMockService, { dataEncapsulation: false , passThruUnknownUrl: true})
    ])],
  providers: [InMemoryBackendMockService],
  declarations: [],
  exports: []
})
export class BackendMockModule {
  constructor() { }
}
